import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from "prop-types";
import { Typography, Icon, Row, Col, Spin, Card, Collapse, Timeline, Form, Input, Button, message } from 'antd'
import { Queries } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import imgcontact from '../../../assets/images/contact.jpg'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { workforce, getToken } from '../../../utils/auth';
import axios from 'axios';
import { apiKeyNews } from '../../../utils/apiKey'
import DashBoradOrgList from './sector/DashBoradOrgList'
import DashBoradEmpList from './sector/DashBoradEmpList'
import axiosAPI, { urlAttachFile } from "../../../config/axiosAPI";

const { Text, Title } = Typography
const { Panel } = Collapse;

class Contact extends React.Component {

      state = {
         dataContact: [],
         dataEmpList: [],
         visibleModal: false,
         //////////////////////addmodalINTERNAL_SERVER_ERROR
         showModalErrors: false,
         preLoadShow: false,
         viewPage: "orgList",
         modeSearch: "search",
         orgUnitCode: null,
         empCode: null, 
         empName: null,
         loadingFullpage: true,
         titleBar: null,
         isCustom: null
      }

      getEmpList = async () => {
         const { token } = getToken();
         const { orgUnitCode, empCode, empName, modeSearch, mode, isCustom} = this.state
         const { match, location } = this.props;
         const API_DEVICE_KEY = atob(apiKeyNews());
   
         await this.setState({
            loadingFullpage: true,
         });
   
         const objectToFetchApi = {
            orgUnitCode,
            page: 1,
            pageSize: 999999,
            mode: modeSearch,
            empCode,
            empName,
            isCustom
         }

         await this.setState({
            viewPage: "empList",
         })

         try{
            const DataFetchAPI = await axiosAPI.get(`${workforce()}/getEmpList`, { params : {...objectToFetchApi}});

            if(DataFetchAPI.status == 200){
               

               await this.setState({
                  dataContact: DataFetchAPI.data.data.empList,
                  preLoadShow:true,
                  loadingFullpage: false,
               });
               // await this.setState({
               //    dataContact: DataFetchAPI.data.data.orgList,
               //    preLoadShow:true,
               //    loadingFullpage: false,
               //    viewPage: "orgList",
               //    modeSearch: "search",
               //    orgUnitCode: null,
               //    empCode: null, 
               //    empName: null,
               //    titleBar: null
               // });
            }
         } catch (error) {
            console.log("error : ", error)
            await this.setState({
               dataContact: [],
               preLoadShow:true,
               loadingFullpage: false,
            });
         }
      };

      handleSubmit = async (e) => {
         const { token } = getToken();
         const { approverId, dataProfile } = this.state
         const { match, location, form } = this.props;
         const API_DEVICE_KEY = atob(apiKeyNews());
   
         // console.log('location.state.approverId', `${workforce()}/fetchAbstainTimeForApproveById?approverId=${approverId}`)
         await e.preventDefault()
         form.validateFields(async (err, values) => {

            if(values.empName){
               await this.setState({
                  modeSearch: "search",
                  viewPage: "empList",
                  // empCode : values.empCode ? values.empCode : null,
                  empName : values.empName ? values.empName : null,
                  dataContact: []
               })
      
               await this.getEmpList()
            }else{
               message.error("กรุณาระบุเงื่อนไขในการค้นหา")
            }
         })
      }
   
   
      getOrgList = async () => {
         const { token } = getToken();
         const { approverId, dataProfile } = this.state
         const { match, location } = this.props;
         const API_DEVICE_KEY = atob(apiKeyNews());
   
         await this.setState({
            loadingFullpage: true,
         });
   
         const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            apiKey: API_DEVICE_KEY,
         };
   
         const objectToFetchApi = {
            // ...values
            page: 1,
            pageSize: 999999
         }
      // const DataFetchAPI = await fetchAPI(objectToFetchApi, "GET", checkLinkURLRestructure()+'/payments')

         try{
            const DataFetchAPI = await axiosAPI.get(`${workforce()}/getOrgList`, { params : {...objectToFetchApi}});

            if(DataFetchAPI.status == 200){
               await this.setState({
                  dataContact: DataFetchAPI.data.data.orgList,
                  preLoadShow:true,
                  loadingFullpage: false,
                  viewPage: "orgList",
                  modeSearch: "search",
                  orgUnitCode: null,
                  empCode: null, 
                  empName: null,
                  titleBar: null
               });
            }
         } catch (error) {
            console.log("error : ", error)
            await this.setState({
               loading: false
            })
         }
      };
      
      searchEmpList = async (values) =>{
         await this.setState({
            orgUnitCode: null,
            modeSearch: "search",
            viewPage: "empList",
            empCode : values.empCode,
            empName : values.empName,
            dataContact: [],
            titleBar: null
         })

         await this.getEmpList()
      }

      viewDetailEmpList = async (orgUnitCode, titleBar, isCustom) =>{
         await this.setState({
            orgUnitCode : orgUnitCode,
            isCustom,
            modeSearch: "detail",
            viewPage: "empList",
            empCode: null, 
            empName: null,
            dataContact: [],
            titleBar,
         })


         await this.getEmpList()
      }

      async componentDidMount() {
         await this.getOrgList()
      }

      render() {
        const { match } = this.props
        const { dataContact, preLoadShow, viewPage, modeSearch, orgUnitID, empCode, empName, dataEmpList, loadingFullpage, titleBar } = this.state
        const { getFieldDecorator } = this.props.form;
        console.log('loadingFullpage', dataContact)
        return (
            <Container match={match}>
               <Spin spinning={loadingFullpage}>

                  <div className="breadcrumb-custom pb-3 mb-5">
                     <span style={{ fontSize: "18px" }}>
                        ข้อมูลติดต่อภายใน { titleBar ? " / "+titleBar : "" }
                     </span>
                  </div>

                  {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                  {
                     this.state.showModalErrors &&
                     <ModalErrors />
                  }
                  {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                  <div id="page-contact">
                     <Form onSubmit={this.handleSubmit}>
                        <Row gutter={16} type="flex" justify="left" align="bottom" className="box-color-white mb-0 py-3" >
                           {/* <Col xs={ 24 } md={8} >
                              <Form.Item label={"รหัสบุคลากร"} className="mb-0">
                                    { getFieldDecorator("empCode", {
                                       initialValue: '',
                                       rules:  [{ 
                                          required:false, 
                                       }],
                                    })(
                                       <Input 
                                          className='block-news' 
                                       />
                                    )}
                              </Form.Item>
                           </Col> */}
                           <Col xs={ 24 } md={8} >
                              <Form.Item label={"ค้นหา"} className="mb-0">
                                    { getFieldDecorator("empName", {
                                       initialValue: '',
                                       rules:  [{ 
                                          required:false, 
                                       }],
                                    })(
                                       <Input 
                                          className='block-news' 
                                       />
                                    )}
                              </Form.Item>
                           </Col>
                           <Col xs={24} md={8}>
                              <Button
                                 type="primary"
                                 id="btn-onsearch"
                                 className="color-white mb-1"
                                 htmlType="submit"
                              >
                                 ค้นหา
                              </Button>
                           </Col>
                           
                        </Row>
                     </Form>
                     {
                        viewPage == 'orgList' ?
                           <DashBoradOrgList
                              viewDetailEmpList={this.viewDetailEmpList}
                              dataContact={dataContact}
                           />
                        :
                           <>
                              <DashBoradEmpList
                                 orgUnitID={orgUnitID}
                                 empCode={empCode}
                                 empName={empName}
                                 modeSearch={modeSearch}
                                 dataContact={dataContact}
                              />
                              <div style={{ textAlign:"center" }} className="mt-4">
                                 <Button 
                                    type="primary" 
                                    className="mx-2 btn-white-red" 
                                    onClick={this.getOrgList}
                                 >
                                    ย้อนกลับ
                                 </Button>
                              </div>
                           </>
                     }
                  </div>
                </Spin>
            </Container>
        )
    }
}
Contact.defaultProps = {
   autoFocus: false,
 };
 
 Contact.propTypes = {
   afterSubmit: PropTypes.func,
   forgotLink: PropTypes.string,
   autoFocus: PropTypes.bool,
 };
 
 const WrappedContact = Form.create()(Contact);
 
 export default withApollo(WrappedContact);